const School = () => {
  return (
    <svg
      width='23'
      height='24'
      viewBox='0 0 23 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.229 10H4.31234V17H6.229V10ZM11.979 10H10.0623V17H11.979V10ZM20.1248 19H1.9165V21H20.1248V19ZM17.729 10H15.8123V17H17.729V10ZM11.0207 3.26L16.0136 6H6.02775L11.0207 3.26ZM11.0207 1L1.9165 6V8H20.1248V6L11.0207 1Z'
        fill='#5A5955'
      />
    </svg>
  );
};

export default School;
